import { getMiddleCenterBias } from '@glideapps/glide-data-grid';

import type { DrawHeaderCallback } from '@glideapps/glide-data-grid';

import type { Lang } from '../types';

import { COLUMN_IDS } from '../constants';

const dateColIndex = COLUMN_IDS.indexOf('date');

type Args = Parameters<DrawHeaderCallback>[0];

const getUserReadableDateFormat = (lang: Lang) => {
  switch (lang) {
    case 'en-GB':
      return 'DD/MM/YYYY';
    case 'en-US':
      return 'MM/DD/YYYY';
    case 'en-CA':
      return 'YYYY/MM/DD';
    default:
      return 'DD/MM/YYYY';
  }
};

export const drawHeaderCells = (
  { ctx, theme, rect, isHovered, columnIndex, column }: Args,
  lang: Lang
) => {
  if (columnIndex < 0) return;

  const title = `${column.title}${
    columnIndex === dateColIndex ? ` (${getUserReadableDateFormat(lang)})` : ''
  }`;

  ctx.fillStyle = isHovered ? theme.bgHeaderHovered : theme.bgHeader;
  ctx.fillRect(rect.x, rect.y, rect.width, rect.height);

  ctx.fillStyle = theme.textDark;
  ctx.fillText(
    title,
    rect.x + theme.cellHorizontalPadding,
    rect.y + rect.height / 2 + getMiddleCenterBias(ctx, theme as any)
  );
};
